<template>
  <div>
    <m-row>
      <m-col lg="6" >

        <!--
        <memlist-text-input 
          v-model="search_text"
          :title="$t('COMMON.SEARCH')"
        />-->

      </m-col>
      <m-col lg="6">
        <div class="d-sm-flex justify-content-end align-items-right align-bottom w-100 mb-2">

          <memlist-pagination 
            :per_page="per_page" 
            :total_rows="total_rows" 
            @page-changed="current_page = $event"
            @per-page-changed="per_page = $event"
            aria-controls="sendout-callback-emails"
          />

        </div>
      </m-col>
    </m-row>


    <memlist-ajax-table
      id="sendout-callback-emails"
      :items="ajax_pagination"
      :fields="headers"
      :per_page="per_page"
      :current_page="current_page"
      ref="ref_sendout_callback"

    >
      
    </memlist-ajax-table>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SendoutEmailCallbackTable',
  components: {
    
  },
  props: {
    sendout_id: { type: Number, required: true },
    type: { type: String, required: true },
  },
  data() {
    return {
      headers: [
      { 
        tdClass: 'td-overflow',
        thClass: 'td-overflow',
        label: 'Mottagare',
        key: 'recipient' 
      },
      { 
        thClass: 'td-short4', 
        tdClass: 'td-short4', 
        label: '', 
        key: 'bounce_reason',
        formatter: (_, __, item) => {
          if (item.type === 'Bounce') {
            return item.bounce_reason;
          }
          
          if (item.type === 'Click') {
            return item.original_link;
          }

          if(item.type === 'Open') {
            return item.platform;
          }

          return '';
        },
      
      },
      ],
      per_page: 20,
      current_page: 1,
      total_rows: 0,
    }
  },
  computed: {
  
  },
  watch: {

    sendout_id: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        
      },
      immediate: true
    },
  },
  beforeDestroy() {
    
  },
  methods: {
    
    ajax_pagination: function(ctx, callback) {
      const vm = this;
      let params = {
        pageNo: ctx.current_page,
        pageSize: ctx.per_page,
        flag: 0,
        po: vm.searchOrderNumber,
        styNum: vm.searchStyleNumber
      };

      
      this.get_pagination(callback);

      return null;
    },

    async get_pagination(callback) {
      const res = await axios.get(`/sendout/delivery/${this.type}/${this.sendout_id}?page=${this.current_page}&limit=${this.per_page}`);

      if (res.status === 200) {
        this.total_rows = res.data.count;

        if (callback) {
          callback(res.data.rows || []);
        }
      }
      
    },

    export_xlsx_clicked() {},
    
  }
}
</script>

<style scoped>
.sendout-row canvas {
  /* Preserve small chart height without letting Chart.js stretch */
  max-height: 96px;
}
</style>
